import { Controller, type Control } from "react-hook-form";

import { Textarea } from "@/components/ui/textarea";

import { TraderDetailsProfileField } from "../TraderDetailsProfileField";
import type { TraderDetailsStepOneFormValues } from "../TraderDetailsStepOne/types";

interface TraderDetailsPhysicalAddressFieldProps {
  control: Control<TraderDetailsStepOneFormValues>;
  errorMessage: string;
  isDisabled?: boolean;
  label: string;
  tooltip: string;
}

export const TraderDetailsPhysicalAddressField = ({
  control,
  errorMessage,
  isDisabled = false,
  label,
  tooltip,
}: TraderDetailsPhysicalAddressFieldProps) => (
  <Controller
    control={control}
    name="physical_address"
    render={({ field }) => (
      <TraderDetailsProfileField
        id="physical_address-input"
        label={label}
        tooltip={tooltip}
        errorMessage={errorMessage}
      >
        <Textarea
          {...field}
          id="physical_address-input"
          value={field.value ?? ""}
          aria-invalid={!!errorMessage}
          aria-describedby={errorMessage ? "physical_address-input-error" : undefined}
          disabled={isDisabled}
          className="min-h-20 resize-y border-border"
        />
      </TraderDetailsProfileField>
    )}
  />
);
